// extracted by mini-css-extract-plugin
export default {"root":"InterruptTooltip_root--c6X","title":"InterruptTooltip_title--O4l","buttons":"InterruptTooltip_buttons--k4w","contentWrapper":"InterruptTooltip_contentWrapper--M43"};